import {Col, ColType, Crud} from "../../comp/crud";
import {ApiClient} from "../../api/ApiClient";
import '../clientConfig/index.scss'
import {TextCell} from "../../comp/cell";
import {
    formatDate,
} from "../../utils";

let cols: Col[] = [
    {
        name: "模块",
        key: "model",
        hideInEdit: true,
        showInFilter: true,
        type: ColType.STRING
    },
    {
        name: "功能",
        key: "description",
        hideInEdit: true,
        showInFilter: true,
        type: ColType.STRING
    },
    {
        name: "客户",
        key: "leadName",
        hideInEdit: true,
        showInFilter: true,
        type: ColType.STRING
    },
    {
        name: "操作对象",
        key: "businessDesc",
        hideInEdit: true,
        showInFilter: true,
        type: ColType.STRING
    },
    {
        name: "操作人",
        key: "userName",
        hideInEdit: true,
        showInFilter: true,
        type: ColType.STRING
    },
    {
        name: "城市",
        key: "city",
        hideInEdit: true,
        showInFilter: false,
        type: ColType.STRING
    },
    {
        name: "角色",
        key: "roleName",
        hideInEdit: true,
        showInFilter: false,
        type: ColType.STRING
    },
    {
        name: "IP",
        key: "accessIp",
        hideInEdit: true,
        showInFilter: false,
        type: ColType.STRING
    },
    {
        name: "操作时间",
        key: "createdAt",
        showInFilter: true,
        type: ColType.DATE_RANGE,
    },
    // {
    //     name: "请求参数",
    //     key: "reqParam",
    //     showInFilter: false,
    //     type: ColType.STRING,
    //     render: a => <TextCell width={300} text={a} />
    // },
    {
        name: "操作结果",
        key: "resParam",
        showInFilter: true,
        type: ColType.STRING,
        render: a => <TextCell width={300} text={a} />
    },

]
export default function UserOperationLog(){
    let nowDate = new Date();       
        const initFilterValues = {
            createdAt: [nowDate, nowDate],
        };

        let startDateStr = formatDate(nowDate);
        let endDateStr = formatDate(nowDate);
        const initParams = {
            createdAt: startDateStr + "," + endDateStr,
        };
    
    return <Crud
        canUpdate={false}
        canCreate={false}
        name="操作日志"
        entityKey="userOperationLogs"
        initFilterValues={initFilterValues}
        initParams={initParams}
        pageSize={50}
        cols={cols}
    />
}